<div class="button-container" *ngIf="isAdmin()">
	<div class="button-container-actions">
		<button type="button" mat-button color="accent"
			class="user-button" [disabled]="isSaving"
			(click)="onEditRole()" *ngIf="!isEditMode">
			<span class="text-color">Edit Role</span>
			<mat-icon iconPositionEnd svgIcon="md:edit" class="icon-color"></mat-icon>
		</button>
		<button type="button" mat-button color="accent"
			class="user-button" [disabled]="isSaving"
			*ngIf="!isEditMode"
			[routerLink]="['add']"><span class="text-color" translate>add-user.add-user</span>
			<mat-icon iconPositionEnd svgIcon="plus" class="icon-color"></mat-icon>
		</button>
	</div>
	<div class="button-container-actions" *ngIf="isEditMode">
		<button type="button" mat-button color="accent" class="user-button cancel-button"
			[disabled]="isSaving"
			(click)="onCancelUserRoleForm()"><span class="text-color" translate>sb.Cancel</span>
		</button>
		<button type="button" mat-button color="accent" class="user-button"
			[disabled]="isSaving"
			(click)="onSaveUserRoleForm()"><span class="text-color" translate>settings.save-changes</span>
			<mat-icon class="icon-color" svgIcon="save_disk"></mat-icon>
		</button>
	</div>
</div>
<div class="card-block">
	<ng-container *ngIf="fetched else loading">
		<ng-container *ngIf="users && gridOptions">
			<div class=" card-title-label" translate>users.list</div>

			<div class="copo-card-grid-container">
				<ag-grid-angular
					class="ag-theme-balham"
					[gridOptions]="gridOptions"
					[modules]="modules"
					(gridReady)="onGridReady($event)"
					(viewportChanged)="onViewportChanged($event)">
				</ag-grid-angular>
			</div>
		</ng-container>
	</ng-container>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>